import { createFileRoute } from "@tanstack/react-router";
import { OrdersPage } from "../components/shop/orders-page.tsx";

export const Route = createFileRoute("/butik/bestallningar/")({ component: OrdersPage });
